module.exports = __webpack_public_path__ + "static/media/comment.843febdc.png";